export default __webpack_public_path__ + "static/media/image-artist-2.539b9fa1.jpg";